<template>
    <div class="d-flex flex-column  position-relative input-section">
        <label :for="id">Question {{index+1}}</label>
        <textarea :id="id" type="text" placeholder="Enter Question" class="q-input w-100"
                  autocomplete="off"
                  @input="questionTextChangeHandler"
                  v-model="template.questions[type].questions[index].question">
   </textarea>

        <span v-if="template.questions[type].questions[index].isDelete && (template.questions[type].questions.length > 1)"
              class="delete-icon" @click="deleteQuestionHandler">
            <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
        </span>

    </div>
</template>


<script>

    import {ref, toRef} from "vue";
    import increaseTemplateQuestions from "../../../helpers/increaseTemplateQuestionsCounter";
    import decreaseTemplateQuestions from "../../../helpers/decreaseTemplateQuestionsCounter";
    import {logger} from "../../../helpers/logger";
    export default {
        name: 'app',
        props: {
            question: String,
            err: Object,
            template: Object,
            validationCB: Function,
            index: Number,
            type: String,
            id: String
        },

        setup(props) {

            const template = toRef(props, 'template');
            const type = toRef(props, 'type');
            const index = toRef(props, 'index');
            const id = toRef(props, 'id');
            const validationCB = toRef(props, 'validationCB');
            let err = toRef(props, 'err');
            const errors = ref([]);
            const changeFlag = ref(false);

            const questionTextChangeHandler = (e) => {

                let errors = null;
                let element = template.value.questions[type.value].questions[index.value];

                errors = validationCB.value(element);
                if (!errors)
                    increaseTemplateQuestions(template, type.value);
                else
                    decreaseTemplateQuestions(template, type.value);
            };

            const deleteQuestionHandler = () => {
                let errors = null;
                logger(['index : ', index.value]);
                let idx = index.value === 0 ? 0 : index.value - 1;
                let element = template.value.questions[type.value].questions[idx];
                errors = validationCB.value(element);
                if (!errors)
                    decreaseTemplateQuestions(template, type.value);
                template.value.questions[type.value].questions.splice(index.value, 1);
            };

            return {
                name,
                errors,
                err,
                changeFlag,
                index,
                type,
                template,
                deleteQuestionHandler,
                questionTextChangeHandler
            }
        }
    }
</script>

<style scoped>
    .q-input {
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        color: var(--main-color);
        padding: 10px;
        overflow-y: scroll;
        overflow-x: hidden;
        min-height: 60px;
        max-height: 60px;
    }

    .q-input:focus-visible{
        outline: none;
    }

    .delete-icon {
        position: absolute;
        top: 16px;
        right: 0;
        display: flex;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: bold;
        color: #E95626;
        cursor: pointer;
    }
</style>